export const GET_ROYALTIES_ACCOUNT = '[Royalties] Get royalties account';
export const GET_ROYALTIES_ACCOUNT_SUCCESS =
  '[Royalties] Get royalties account Success';
export const GET_ROYALTIES_ACCOUNT_ERROR =
  '[Royalties] Get royalties account Error';

export const DELETE_ROYALTIES_ACCOUNT = '[Royalties] Delete royalties account';
export const DELETE_ROYALTIES_ACCOUNT_SUCCESS =
  '[Royalties] Delete royalties account Success';
export const DELETE_ROYALTIES_ACCOUNT_ERROR =
  '[Royalties] Delete royalties account Error';

export const REGISTER_ROYALTIES_ACCOUNT =
  '[Royalties] Register royalties account';
export const REGISTER_ROYALTIES_ACCOUNT_SUCCESS =
  '[Royalties] Register royalties account Success';
export const REGISTER_ROYALTIES_ACCOUNT_ERROR =
  '[Royalties] Register royalties account Error';

export const LIST_PAYOUTS = '[Royalties] List payouts';
export const LIST_PAYOUTS_SUCCESS = '[Royalties] List payouts Success';
export const LIST_PAYOUTS_ERROR = '[Royalties] List payouts Error';
export const RESET_NEW_ROYALTIES_ACCOUNT = '[Royalties] Reset new account';

export const GET_BALANCE = '[Royalties] Get Balance';
export const GET_BALANCE_SUCCESS = '[Royalties] Get Balance Success';
export const GET_BALANCE_ERROR = '[Royalties] Get Balance Error';

export const GET_STATEMENTS = '[Royalties] Get Statements';
export const GET_STATEMENTS_SUCCESS = '[Royalties] Get Statements Success';
export const GET_STATEMENTS_ERROR = '[Royalties] Get Statements Error';

export const UPDATE_FIELD = '[Royalties] Update Field';
